import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { MediaUnlockContext } from './mediaUnlockContextValue';
import { probeUnmutedAutoplay } from './probeUnmutedAutoplay';
/**
 * 페이지 트리에 unlocked 상태를 공유한다.
 * 리로드 시 Provider가 다시 마운트되며 재프로브한다.
 */
export function MediaUnlockProvider({ enabled = true, children }) {
    const [phase, setPhase] = useState(enabled ? 'probing' : 'unlocked');
    const probeGenerationRef = useRef(0);
    const runProbe = useCallback(async () => {
        if (!enabled) {
            setPhase('unlocked');
            return;
        }
        const generation = ++probeGenerationRef.current;
        setPhase('probing');
        const result = await probeUnmutedAutoplay();
        if (generation !== probeGenerationRef.current)
            return;
        setPhase(result.ok ? 'unlocked' : 'locked');
    }, [enabled]);
    useEffect(() => {
        void runProbe();
        return () => {
            probeGenerationRef.current += 1;
        };
    }, [runProbe]);
    const requestUnlock = useCallback(() => {
        if (!enabled)
            return;
        void runProbe();
    }, [enabled, runProbe]);
    const value = {
        phase,
        unlocked: phase === 'unlocked',
        showStrap: enabled && phase === 'locked',
        requestUnlock,
    };
    return _jsx(MediaUnlockContext.Provider, { value: value, children: children });
}
//# sourceMappingURL=MediaUnlockProvider.js.map